/**
 * WordPress dependencies
 */
import { postCommentsCount as icon } from '@wordpress/icons';
/**
 * Internal dependencies
 */

const metadata = {
  $schema: "https://schemas.wp.org/trunk/block.json",
  apiVersion: 2,
  __experimental: "fse",
  name: "core/post-comments-link",
  title: "Post Comments Link",
  category: "theme",
  description: "Displays the link to the current post comments.",
  textdomain: "default",
  usesContext: ["postType", "postId"],
  attributes: {
    textAlign: {
      type: "string"
    }
  },
  supports: {
    html: false,
    color: {
      link: true,
      text: false,
      __experimentalDefaultControls: {
        background: true,
        link: true
      }
    },
    typography: {
      fontSize: true,
      lineHeight: true,
      __experimentalFontStyle: true,
      __experimentalFontWeight: true,
      __experimentalLetterSpacing: true,
      __experimentalTextTransform: true,
      __experimentalDefaultControls: {
        fontSize: true
      }
    }
  }
};
import edit from './edit';
const {
  name
} = metadata;
export { metadata, name };
export const settings = {
  edit,
  icon
};
//# sourceMappingURL=index.js.map